import PropTypes from 'prop-types';
export var asPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]);
export var stylePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]);
//# sourceMappingURL=styledComponent.js.map